import React from 'react'

export const StoreItem = React.memo((tienda) => {
    // const urlGoogle = `https://www.google.com/maps/search/?api=1&query=${ tienda.latitude },${ tienda.longitude }&zoom=20`;
    // const urlApple = `https://maps.apple.com/?ll=${ tienda.latitude },${ tienda.longitude }&t=m`;

    const mapsSelector =()=> {
        if /* if we're on iOS, open in Apple Maps */
          ((navigator.platform.indexOf("iPhone") !== -1) || 
           (navigator.platform.indexOf("iPad") !== -1) || 
           (navigator.platform.indexOf("iPod") !== -1))
           
          window.open(`maps://maps.google.com/maps?daddr=${ tienda.latitude },${ tienda.longitude }&amp;ll=`);
      else /* else use Google */
          window.open(`https://www.google.com/maps/search/?api=1&query=${ tienda.latitude },${ tienda.longitude }&zoom=20`);
      }

    return (
        <div className="animate__animated animate__fadeIn cardTienda" onClick={mapsSelector}>
                        <div className="nomTienda">{tienda.tipo === "Bimbonet" ? "Punto de recarga" : tienda.tipo}</div>
                        <div className="distance">{tienda.distance !== 0 ? tienda.distance +'m' : ''}</div>
                        <div className="horario" ><span className={`horario ${tienda.isOpen === "Abierto" && "verde"}`}>{tienda.isOpen !== '' && tienda.isOpen+' - '}</span>{tienda.horario}</div>
                        <div  className="icoGo animate__animated animate__bounceInDown"></div>
                        <span className="texto_oculto">Abrir ubicación en el mapa</span>
        </div>
    )
})
